import React, { useState, useEffect } from 'react';
import NumericKeypad from './NumericKeypad'; // Importa el nuevo teclado numérico

const UnitsInputModal = ({ operationId, currentUnits, onConfirm, onClose, context }) => {
  const [units, setUnits] = useState(String(currentUnits)); // Mantener como string para el teclado
  const [message, setMessage] = useState('');

  useEffect(() => {
    setUnits(String(currentUnits)); // Asegura que el valor inicial sea un string
  }, [currentUnits]);

  const handleKeyPress = (key) => {
    setMessage(''); // Limpiar mensaje de error al teclear
    if (key === 'C') {
      setUnits('0');
    } else if (key === '←') {
      setUnits(prevUnits => (prevUnits.length > 1 ? prevUnits.slice(0, -1) : '0'));
    } else {
      setUnits(prevUnits => (prevUnits === '0' ? key : prevUnits + key));
    }
  };

  const handleConfirm = () => {
    const parsedUnits = parseInt(units);
    if (isNaN(parsedUnits) || parsedUnits < 0) {
      setMessage('Por favor, ingresa un número válido de unidades.');
      return;
    }
    onConfirm(operationId, parsedUnits);
    onClose();
  };

  const modalTitle = context === 'pause' ? 'Unidades Fabricadas al Pausar' : 'Unidades Fabricadas';
  const confirmButtonText = context === 'pause' ? 'Pausar y Guardar' : 'Guardar Unidades';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-2xl shadow-xl max-w-sm w-full transform transition-all scale-100 opacity-100 duration-300">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">{modalTitle}</h2>
        <div className="mb-6">
          <label htmlFor="units-display" className="block text-gray-700 text-base font-medium mb-2">Unidades:</label>
          <div
            id="units-display"
            className="w-full px-4 py-3 bg-gray-100 border border-gray-300 rounded-lg shadow-sm text-right text-2xl font-bold text-gray-900 mb-4"
          >
            {units}
          </div>
          <NumericKeypad onKeyPress={handleKeyPress} />
          {message && <p className="text-red-500 text-sm mt-3 text-center">{message}</p>}
        </div>
        <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0 justify-end">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition-colors font-semibold text-base"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold text-base"
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnitsInputModal;